import { render, staticRenderFns } from "./tzH5.vue?vue&type=template&id=1095b0f6&scoped=true"
import script from "./tzH5.vue?vue&type=script&lang=js"
export * from "./tzH5.vue?vue&type=script&lang=js"
import style0 from "./tzH5.vue?vue&type=style&index=0&id=1095b0f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1095b0f6",
  null
  
)

export default component.exports